<ng-template #content>
  @if (ctx; as ctx) {
    <button type="button" class="btn-close two-factor-close" [disabled]="ctx.submitting" (click)="cancel()" aria-label="Close"></button>

    <div class="two-factor-hero">
      <div class="two-factor-icon">
        <i class="bi bi-shield-lock-fill"></i>
      </div>
      <h5 class="two-factor-title">Two-factor authentication</h5>
      <p class="two-factor-subtitle">Enter the 6-digit code from your authenticator app to continue.</p>
    </div>

    <div class="modal-body">
      <div class="two-factor-digits" [class.shake]="shake" (paste)="onPaste($event)">
        @for (digit of digits; track $index) {
          <input
            type="text"
            inputmode="numeric"
            autocomplete="off"
            data-1p-ignore="true"
            data-lpignore="true"
            class="two-factor-digit-input"
            [class.is-invalid]="ctx.error"
            [disabled]="ctx.submitting"
            [value]="digit"
            (input)="onDigitInput($index, $event)"
            (keydown)="onKeyDown($index, $event)" />
        }
      </div>

      @if (ctx.error) {
        <p class="two-factor-error"><i class="bi bi-exclamation-circle-fill me-1"></i>{{ ctx.error }}</p>
      }
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" [disabled]="ctx.submitting" (click)="cancel()">Cancel</button>
      <button type="button" class="btn btn-primary two-factor-submit" [disabled]="ctx.submitting || code.length !== 6" (click)="submit()">
        @if (ctx.submitting) {
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Verifying...
        } @else {
          Verify
        }
      </button>
    </div>
  }
</ng-template>
